import { render, staticRenderFns } from "./PriceListGroupList.vue?vue&type=template&id=999df004"
import script from "./PriceListGroupList.vue?vue&type=script&lang=js"
export * from "./PriceListGroupList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports